/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { DeleteSystemCategoryComponent } from '../../delete-system-category/delete-system-category.component';
import { DeleteSystemCategory } from '../../models/delete-system-category';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class DeleteSystemCategoryDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig, componentTitle?: string): any {
    sysquePopupConfig.component = DeleteSystemCategoryComponent;
    const deleteSystem = new DeleteSystemCategory();
    deleteSystem.msgSystemCategorymName = 'XYZ';
    sysquePopupConfig.data = deleteSystem;
    sysquePopupConfig.width = 505;
    sysquePopupConfig.height = 225;
    sysquePopupConfig.componentTitle = componentTitle;
  }
}
